module.exports = __webpack_public_path__ + "img/witness.813c0584.svg";